import YobInputField from "@frameworks/web/components/generic/OtpGeneric";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import di from "@frameworks/web/components/features/LoginFlow/di/servicelocator";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ErrorExclamation from "@frameworks/web/components/generic/errorExclamation";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import GenericTooltip from "@frameworks/web/components/generic/GenericTooltip";
import { loginScreenState } from "../constant";
const GuestSetMPIN = (props) => {
    const navigate = useNavigate();
    const device = DeviceContext();
    const [pin, setPin] = useState("");
    const [confirmPin, setConfirmPin] = useState("");
    const [proceedToLogin, setProceedToLogin] = useState(false);
    const [serverError, setServerError] = useState({
        isOpen: false,
        msg: "",
    });
    const exceptThisSymbols = ["e", "E", "+", "-", "."];
    function handlekeyEvent(e) {
        exceptThisSymbols.includes(e.key) && e.preventDefault();
        if (e.keyCode === 8) {
        }
    }
    const { data: getAccountDetails, loader: getAccountDetailsLoader } = useSelector((state) => state.LoginFlow.getAccountDetails);
    const { data: guestRegister, loader: guestRegisterLoader } = useSelector((state) => state.LoginFlow.guestRegister);
    const { data: guestValidateMPIN, loader: guestValidateMPINLoader, errorData: guestValidateMPINError, } = useSelector((state) => state.LoginFlow.guestValidateMPIN);
    const onSubmit = () => {
        if (getAccountDetails.guestId || guestRegister.uniqueID) {
            const payload = {
                pin: String(pin),
                unId: getAccountDetails.guestId || guestRegister.uniqueID,
                mob: getAccountDetails.mobile,
                countryCode: "91",
            };
            di.login
                .guestLoginSetMPIN(payload)
                .then((val) => {
                if (props.forgetFlow) {
                    props.setForgetFlow(false);
                    props.navigateTo();
                }
                else {
                    val.status && setProceedToLogin(true);
                    props.setProceedToLogin && props.setProceedToLogin(true);
                }
            })
                .catch((error) => {
                setServerError({
                    isOpen: true,
                    msg: error === null || error === void 0 ? void 0 : error.getErrorMessageOrErrMsg(),
                });
            });
        }
    };
    const disableSubmit = () => {
        return (confirmPin.toString() !== pin.toString() ||
            pin.toString().length !== 4 ||
            (props.disableSubmit && props.disableSubmit()));
    };
    useEffect(() => {
        if (proceedToLogin) {
            if (getAccountDetails.mobile && pin) {
                let payload = {
                    pin: pin,
                    mob: getAccountDetails.mobile,
                    countryCode: "91",
                };
                di.login.GuestValidateMPIN(payload);
            }
        }
    }, [proceedToLogin]);
    useEffect(() => {
        if (!guestValidateMPINLoader &&
            !guestValidateMPINError.isOpen &&
            guestValidateMPIN.status &&
            proceedToLogin) {
            if (!props.forgetFlow)
                props.setScreenState(loginScreenState.GUEST_LOGIN_TRIAL);
        }
        else if (guestValidateMPINError.isOpen) {
            setServerError({
                isOpen: guestValidateMPINError.isOpen,
                msg: guestValidateMPINError.error.getErrorMessageOrErrMsg(),
            });
        }
    }, [
        guestValidateMPIN,
        guestValidateMPINLoader,
        guestValidateMPINError,
        proceedToLogin,
    ]);
    useEffect(() => {
        if ((pin || confirmPin) && (serverError === null || serverError === void 0 ? void 0 : serverError.isOpen)) {
            setServerError({
                isOpen: false,
                msg: "",
            });
        }
    }, [pin, confirmPin]);
    return (React.createElement("div", { className: "set-mpin-block" },
        device && device.isDesktop ? (React.createElement(React.Fragment, null)) : (React.createElement(React.Fragment, null,
            " ",
            React.createElement(Row, { className: "pt-3" },
                React.createElement(Col, { lg: 12, className: "DMSansBold_20_700 px-0" }, props.title ? props.title : " Forgot PIN")))),
        React.createElement(Row, { className: "mt-4  px-0" },
            React.createElement("div", { className: "d-flex align-items-center" },
                React.createElement("span", { className: "DMSanN_16_400 txt_primaryGrey" }, "Please set a new PIN"),
                React.createElement("span", { className: "ps-2" },
                    React.createElement(GenericTooltip, { triggerType: "hover", placement: "bottom", button: React.createElement(React.Fragment, null,
                            React.createElement("div", null,
                                React.createElement("span", { className: "rounded-circle exclamation ps-2" },
                                    React.createElement("i", { className: "edel-icon-info" })))), toolTipClassName: "blue-common-tooltip ", externalClassName: "common-tooltip ", toolTipText: "Create a 4-digit numerical PIN, for easy login in the future" })))),
        React.createElement("form", null,
            React.createElement(Row, { className: "mt-4 m-0" },
                React.createElement(YobInputField, { onChange: (value) => {
                        setPin(value);
                    }, 
                    // applyForm={true}
                    inputClassName: "Pin", id: "pin-", type: "password", min: 0, max: 1, focus: true, onKeyDown: (e) => handlekeyEvent(e), childClassName: "pin" }))),
        React.createElement("form", { onSubmit: (e) => {
                e.preventDefault();
                props.onSubmit ? props.onSubmit(pin) : onSubmit();
            } },
            React.createElement(Row, { className: "mt-4 DMSanN_16_400 txt_primaryGrey" }, "Confirm the new PIN"),
            React.createElement(Row, { className: "mt-4 m-0" },
                React.createElement(YobInputField, { showConfirmPinInNumbers: (props === null || props === void 0 ? void 0 : props.showConfirmPinInNumbers)
                        ? props === null || props === void 0 ? void 0 : props.showConfirmPinInNumbers
                        : false, onChange: function (value) {
                        setConfirmPin(value);
                    }, type: "number", min: 0, max: 9, focus: false, onKeyDown: (e) => handlekeyEvent(e), id: "confirmPin-", inputClassName: "confirmPin" })),
            (proceedToLogin || props.proceedToLogin) && !serverError.isOpen && (React.createElement(Row, { className: "DMSans_16_500 my-4 bg-rose-white txt-faded-orange text-center d-flex" },
                React.createElement("span", null, "PIN has been set successfully! We\u2019re logging you in shortly."))),
            props.errorState && !serverError.isOpen && (React.createElement(Row, { className: "DMSans_16_500 my-4" },
                " ",
                "Due to technical error , operation has failed. Please try again.")),
            !guestValidateMPINLoader && serverError.isOpen && (React.createElement(ErrorExclamation, { errorMessage: serverError.msg, avoidBackground: true })),
            confirmPin.toString() !== pin.toString() &&
                pin.toString().length == 4 &&
                confirmPin.length == 4 && (React.createElement(ErrorExclamation, { errorMessage: "PIN does not match. Re-enter your PIN", avoidBackground: true, parentClass: "mpinissue-error" })),
            React.createElement(Row, { className: "m-0 otppage-button" },
                React.createElement(EdButton, { btnTyp: "midnight-blue", disabled: disableSubmit() ||
                        guestValidateMPINLoader ||
                        getAccountDetailsLoader ||
                        serverError.isOpen, value: "Register", type: "submit" })))));
};
export default GuestSetMPIN;
